class UgcVideoCarouselSection {
  constructor(root) {
    this.carousel = root.querySelector('[data-ugc-carousel]');
    if (!this.carousel) return;

    this.track = this.carousel.querySelector('[data-ugc-track]');
    this.prevButton = this.carousel.querySelector('[data-ugc-prev]');
    this.nextButton = this.carousel.querySelector('[data-ugc-next]');
    if (!this.track || !this.prevButton || !this.nextButton) return;

    this.prevButton.addEventListener('click', () => {
      this.track.scrollBy({ left: -this.track.clientWidth, behavior: 'smooth' });
    });

    this.nextButton.addEventListener('click', () => {
      this.track.scrollBy({ left: this.track.clientWidth, behavior: 'smooth' });
    });

    this.track.addEventListener('scroll', () => this.updateButtons());
    window.addEventListener('resize', () => this.updateButtons());

    this.updateButtons();
  }

  updateButtons() {
    const maxScrollLeft = this.track.scrollWidth - this.track.clientWidth - 1;
    this.prevButton.disabled = this.track.scrollLeft <= 0;
    this.nextButton.disabled = this.track.scrollLeft >= maxScrollLeft;
  }
}

document.querySelectorAll('.ugc-video-carousel-section').forEach((section) => {
  new UgcVideoCarouselSection(section);
});
